/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this file will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function () {

  // Prevent re-entrancy and track processing state
  let isProcessing = false;

  // ---- cache version (invalidate old derived year/model caches) ----
  const FILTER_CACHE_VER = '2';
  try {
    const key = 'filterCacheVersion';
    const cur = localStorage.getItem(key);
    if (cur !== FILTER_CACHE_VER) {
      Object.keys(localStorage).forEach(k => {
        if (/^(years_|modelItems_|modelYearMap_|models_)/.test(k)) localStorage.removeItem(k);
      });
      localStorage.setItem(key, FILTER_CACHE_VER);
    }
  } catch(e) {}

  // Static list of makes
  const makeList = [
    "Aprilia","Benelli","BMW","Can-Am","Ducati","EBR",
    "Harley Davidson","Honda","Husqvarna","Indian","Kawasaki",
    "KTM","Moto Guzzi","MV Agusta","Piaggio","Suzuki",
    "Triumph","Vespa","Yamaha"
  ];

  function makeToCollectionHandle(make) {
    return String(make || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  // Toggle open/close of filter sections
  $(document).on("click", ".filter-container .filter-item", function(e) {
    // If the click originated on an <li> inside a <ul>, exit early
    if ($(e.target).closest("ul li").length) return;
    if (isProcessing) return;
    isProcessing = true;

    const $this = $(this),
          filterName = $this.attr("data-filter"),
          $active = $(".filter-container .filter-item.active");

    if ($active.length && $active.attr("data-filter") === filterName) {
      $this.removeClass("active");
    } else {
      $active.removeClass("active");
      $this.addClass("active");
    }

    isProcessing = false;
  });

  // Populate Make dropdown on load
  (function populateMakes() {
    let html = "";
    makeList.forEach(make => {
      html += `<li data-value="${make}">${make}</li>`;
    });
    $(".filters #make").html(html);
  })();

  // ---------- Utilities ----------

  // Extract {text, value} items from a <ul> list
  function extractOptionsFromUl(ul) {
    return Array.from(ul.querySelectorAll("li")).map(li => {
      const input = li.querySelector('input');
      const isHidden = li.hidden
        || li.getAttribute('aria-hidden') === 'true'
        || li.style.display === 'none'
        || window.getComputedStyle(li).display === 'none';
      if (isHidden || (input && input.disabled)) return null;

      const val = li.getAttribute("data-value")
        || (input?.getAttribute('value'))
        || '';

      // Work on a clone so we don't mutate the fetched/facet DOM while extracting text.
      const clone = li.cloneNode(true);
      clone.querySelectorAll("input, svg, use, button").forEach(el => el.remove());
      const text = (clone.textContent || '').replace(/\s+/g, ' ').trim();

      if (!text && !val) return null;
      if (/^show\s+(more|less)$/i.test(text)) return null;
      return { text: text || val, value: val || text };
    }).filter(Boolean);
  }

  // ---------- Year helpers (pivot + parsing) ----------

  // Y2K pivot for 2-digit years: 00–39 -> 2000–2039, 40–99 -> 1940–1999
  const TWO_DIGIT_PIVOT = 40;
  function normalizeYear(y) {
    const n = parseInt(String(y).trim(), 10);
    if (isNaN(n)) return null;
    if (n < 100) return (n < TWO_DIGIT_PIVOT) ? (2000 + n) : (1900 + n);
    return n;
  }
  function toFullYear(v) {
    return normalizeYear(v);
  }

  // Parse years from a model label.
  // RULE: If any hyphen ranges exist, ONLY use those ranges.
  //       Singles (e.g., "25") are only used when there is NO range in the label.
  function extractYearsFromLabel(label) {
    if (!label) return [];
    const s = String(label)
      .replace(/[–—]/g, '-')     // normalize fancy dashes
      .replace(/\bMY\s*/gi, ''); // strip MY markers

    const years = new Set();
    let foundRange = false;

    // Ranges like 99-05 or 2021-2025 (allow 2- or 4-digit)
    const rangeRe = /(?:^|[^\d])(\d{2}|\d{4})\s*-\s*(\d{2}|\d{4})(?=$|[^\d])/g;
    let m;
    while ((m = rangeRe.exec(s)) !== null) {
      let a = toFullYear(m[1]);
      let b = toFullYear(m[2]);
      if (a == null || b == null) continue;
      foundRange = true;
      if (b < a) [a, b] = [b, a];
      for (let y = a; y <= b; y++) years.add(y);
    }

    // If no range present, allow single 2- or 4-digit tokens (avoid engine sizes like 650 naturally)
    if (!foundRange) {
      const singleRe = /(?:^|[^\d])(\d{2}|\d{4})(?=$|[^\d])/g;
      while ((m = singleRe.exec(s)) !== null) {
        const y = toFullYear(m[1]);
        if (y != null) years.add(y);
      }
    }

    return Array.from(years);
  }

  // Check if a label includes the selected year using the same parser (keeps rules consistent)
  function matchesSelectedYear(label, selectedYearFull) {
    const years = extractYearsFromLabel(label);
    return years.includes(selectedYearFull);
  }

  // Build a sorted (desc) unique Year list from model <li> items
  function deriveYearsFromModelItems(modelItems) {
    const set = new Set();
    modelItems.forEach(i => {
      extractYearsFromLabel(i.text).forEach(y => set.add(y));
    });
    return Array.from(set)
      .sort((a, b) => b - a)
      .map(y => ({ text: String(y), value: String(y) }));
  }

  // ---------- Facet & grid helpers ----------

  // Get the "Model" facet <ul> from a collection page document (multiple fallbacks)
  function getModelFacetUl(doc) {
    const sels = [
      'ul[id^="accordion-model-"]',
      '[data-filter-group="Model"] ul',
      'ul[data-filter="Model"]',
      'ul.js-filter-model',
      'ul#Filter-Accordion-Model'
    ];

    const candidates = [];
    sels.forEach((s) => {
      doc.querySelectorAll(s).forEach((ul) => candidates.push(ul));
    });
    if (!candidates.length) return null;

    // Some themes render multiple filter UIs (desktop/mobile/drawer).
    // Pick the one with the most real model inputs to avoid truncated lists.
    let best = null;
    let bestScore = -1;
    candidates.forEach((ul) => {
      const modelInputCount = ul.querySelectorAll('input[name="filter.p.m.custom.model"]').length;
      const modelLiCount = ul.querySelectorAll('li.filter__button').length;
      const score = modelInputCount * 1000 + modelLiCount;
      if (score > bestScore) {
        best = ul;
        bestScore = score;
      }
    });

    return best || candidates[0];
  }

  // Fallback: Extract unique Model options from the filtered product grid (robust; year-aware if provided)
  function extractModelsFromGrid(doc, selectedYearFull /* can be null */) {
    const modelsMap = new Map();
    const normalize = (s) => (s || '').replace(/\s+/g, ' ').trim();

    // read a container into separate "lines"
    const linesFromEl = (el) => {
      if (!el) return [];
      const lines = [];

      // Prefer child elements as individual lines
      const kids = Array.from(el.children || []);
      if (kids.length) {
        kids.forEach(k => {
          const txt = normalize(k.innerText || k.textContent);
          if (txt) lines.push(txt);
        });
      }

      // If nothing yet, split on <br>
      if (!lines.length) {
        const html = el.innerHTML || '';
        if (/<br\s*\/?>/i.test(html)) {
          html.split(/<br\s*\/?>/ig)
            .map(chunk => normalize(chunk.replace(/<\/?[^>]+>/g, '')))
            .filter(Boolean)
            .forEach(v => lines.push(v));
        }
      }

      // Fallback: split on newlines from innerText
      if (!lines.length) {
        const txt = (el.innerText || el.textContent || '').replace(/\r/g, '');
        txt.split('\n').map(normalize).filter(Boolean).forEach(v => lines.push(v));
      }

      // Final fallback: delimiters like bullets/commas
      if (lines.length === 1) {
        const pieces = lines[0].split(/(?:•|,|;)\s*/).map(normalize).filter(Boolean);
        if (pieces.length > 1) return pieces;
      }

      return lines;
    };

    const products = Array.from(
      doc.querySelectorAll('.product-grid-item, .custom--product-grid-item, .product__grid__item')
    );

    products.forEach((p) => {
      let found = false;
      const multiContainers = p.querySelectorAll('.model.small .multi-model');
      if (multiContainers.length) {
        found = true;
        multiContainers.forEach(el => {
          linesFromEl(el).forEach(line => {
            if ((selectedYearFull == null || matchesSelectedYear(line, selectedYearFull)) && !modelsMap.has(line)) {
              modelsMap.set(line, { text: line, value: line });
            }
          });
        });
      }
      if (!found) {
        const container = p.querySelector('.model.small, [data-model]');
        if (!container) return;
        linesFromEl(container).forEach(line => {
          if ((selectedYearFull == null || matchesSelectedYear(line, selectedYearFull)) && !modelsMap.has(line)) {
            modelsMap.set(line, { text: line, value: line });
          }
        });
      }
    });

    return Array.from(modelsMap.values())
      .sort((a,b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' }));
  }

  // Render helper: replace <ul> content with given items
  function renderList($ul, items) {
    const html = items.map(i => `<li data-value="${i.value}">${i.text}</li>`).join("");
    $ul.html(html);
  }

  // ---------- Make / Year / Model selection ----------

  $(document).on("click", ".filter-item ul li", async function () {
    if (isProcessing) return;
    isProcessing = true;

    const $li     = $(this);
    const $item   = $li.closest(".filter-item");
    const type    = $item.attr("data-filter");   // "Make" | "Year" | "Model"
    const value   = $li.attr("data-value");
    const label   = $li.text().trim();
    const $fc     = $item.closest(".filter-container");
    const $makeF  = $fc.find('[data-filter="Make"]');
    const $yearF  = $fc.find('[data-filter="Year"]');
    const $modelF = $fc.find('[data-filter="Model"]');

    // Update the selected value and visible label
    $item.attr("data-selected", value).find("span").text(label);
    $item.removeClass('active');

    try {
      if (type === "Make") {
        // Spinners
        const yearSpinner  = $yearF.find('span');
        const modelSpinner = $modelF.find('span');
        yearSpinner.addClass('lds-dual-ring').text('');
        modelSpinner.addClass('lds-dual-ring').text('');

        // Reset selections
        $yearF.attr("data-selected", "").find("span").text("Year");
        $modelF.attr("data-selected", "").find("span").text("Model");
        $yearF.find("ul").empty();
        $modelF.find("ul").empty();

        // Fetch the make collection page ONCE
        const makeSlug = makeToCollectionHandle(value);
        const res = await fetch(`/collections/${makeSlug}`);
        const html = await res.text();
        const doc  = new DOMParser().parseFromString(html, "text/html");

        // 1) Build MODEL list (prefer facet; fallback to grid, no year filter)
        let modelItems = [];
        const modelUl = getModelFacetUl(doc);
        if (modelUl) {
          modelItems = extractOptionsFromUl(modelUl);
        } else {
          modelItems = extractModelsFromGrid(doc, null); // null => all years
        }

        // Render Model dropdown
        if (modelItems.length) {
          renderList($modelF.find("ul"), modelItems);
          try { localStorage.setItem(`modelItems_${makeSlug}`, JSON.stringify(modelItems)); } catch(e) {}
        } else {
          $modelF.find("ul").empty();
          try { localStorage.removeItem(`modelItems_${makeSlug}`); } catch(e) {}
        }

        // Build model -> years map from labels (used later for Year filtering)
        const modelYearMap = {};
        modelItems.forEach(it => {
          const yrs = extractYearsFromLabel(it.text);
          if (yrs && yrs.length) modelYearMap[it.text] = yrs;
        });
        try { localStorage.setItem(`modelYearMap_${makeSlug}`, JSON.stringify(modelYearMap)); } catch(e) {}

        // 2) Derive YEAR options from those model labels
        const yearsFromModels = deriveYearsFromModelItems(modelItems);

        // Render Year dropdown (derived from models)
        if (yearsFromModels.length) {
          renderList($yearF.find("ul"), yearsFromModels);
          try { localStorage.setItem(`years_${makeSlug}_from_models`, JSON.stringify(yearsFromModels)); } catch(e) {}
        } else {
          $yearF.find("ul").empty();
          try { localStorage.removeItem(`years_${makeSlug}_from_models`); } catch(e) {}
        }

        // Clear spinners
        yearSpinner.removeClass('lds-dual-ring').text("Year");
        modelSpinner.removeClass('lds-dual-ring').text("Model");
      }

      else if (type === "Year") {
        // spinner on Model
        const spinner_container = $modelF.find('span');
        spinner_container.addClass('lds-dual-ring').text('');

        // Reset Model when Year is changed
        const makeSelected = $makeF.attr("data-selected");
        if (!makeSelected) {
          $modelF.find("ul").empty();
          spinner_container.removeClass('lds-dual-ring').text("Model");
          isProcessing = false;
          return;
        }

        const makeSlug = makeToCollectionHandle(makeSelected);
        const selectedYearFull = normalizeYear(value);

        // Preferred: use the cached model->years mapping generated at Make selection
        let items = [];
        try {
          const mapStr = localStorage.getItem(`modelYearMap_${makeSlug}`);
          const allItemsStr = localStorage.getItem(`modelItems_${makeSlug}`);
          if (mapStr && allItemsStr) {
            const map = JSON.parse(mapStr);          // { "SR Motard 50 12-20": [2012,...,2020], ... }
            const allItems = JSON.parse(allItemsStr); // [{text, value}, ...]
            items = allItems.filter(mi => {
              const yrs = map[mi.text] || [];
              return yrs.includes(selectedYearFull);
            });
          }
        } catch (e) {
          console.warn('Model-year map unavailable, will rebuild on the fly:', e);
        }

        // Fallback: rebuild from the Make page (no server year facet), then filter by label years
        if (!items.length) {
          try {
            const res = await fetch(`/collections/${makeSlug}`);
            const html = await res.text();
            const doc  = new DOMParser().parseFromString(html, "text/html");

            let allModelItems = [];
            const modelUl = getModelFacetUl(doc);
            if (modelUl) {
              allModelItems = extractOptionsFromUl(modelUl);
            } else {
              allModelItems = extractModelsFromGrid(doc, null);
            }

            items = allModelItems.filter(mi => {
              const yrs = extractYearsFromLabel(mi.text);
              return yrs.includes(selectedYearFull);
            });

            // Cache for later interactions
            try { localStorage.setItem(`modelItems_${makeSlug}`, JSON.stringify(allModelItems)); } catch(e) {}
            const rebuiltMap = {};
            allModelItems.forEach(it => {
              const yrs = extractYearsFromLabel(it.text);
              if (yrs.length) rebuiltMap[it.text] = yrs;
            });
            try { localStorage.setItem(`modelYearMap_${makeSlug}`, JSON.stringify(rebuiltMap)); } catch(e) {}
          } catch (err) {
            console.error('Rebuild model-year map failed:', err);
          }
        }

        if (items.length) {
          renderList($modelF.find("ul"), items);
          localStorage.setItem(`models_${makeSlug}_${value}`, JSON.stringify(items));
        } else {
          $modelF.find("ul").empty();
          localStorage.removeItem(`models_${makeSlug}_${value}`);
        }

        spinner_container.removeClass('lds-dual-ring').text("Model");
      }

      // No special action on Model itself

    } catch (err) {
      console.error("Filter error:", err);
    } finally {
      isProcessing = false;
    }
  });

  // Build URL & redirect on Search click — ONLY filter by MODEL (no year)
  $(document).on("click", ".filter-container .filter-submit", function() {
    if (isProcessing) return;
    isProcessing = true;

    const $fc   = $(this).closest(".filter-container"),
          make  = $fc.find('[data-filter="Make"][data-selected]').attr("data-selected"),
          model = $fc.find('[data-filter="Model"][data-selected]').attr("data-selected");

    const makeHandle = makeToCollectionHandle(make);
    if (!makeHandle) {
      isProcessing = false;
      return;
    }

    const url = new URL(`/collections/${makeHandle}`, window.location.origin);
    if (model) url.searchParams.set("filter.p.m.custom.model", model);
    url.searchParams.set("sort_by", "best-selling");

    window.location.href = url.toString();
    isProcessing = false;
  });

  // ====== DROP-IN REPLACEMENT ======

(function () {
  // ---------- helpers ----------
  const CACHE_VERSION = 'v11-2026-06-25'; // bump this anytime you change menu behaviour
  const ONE_WEEK = 7 * 24 * 60 * 60 * 1000;

  const normalize = (s) =>
    (s || '')
      .replace(/\u00A0/g, ' ')     // NBSP
      .replace(/[–—]/g, '-')       // dash variants
      .replace(/\s+/g, ' ')        // collapse whitespace
      .trim()
      .toLowerCase();

  const getModelTitleFromCard = (productEl) => {
    const multi = productEl.querySelector('.model.small .multi-model');
    const single = productEl.querySelector('.model.small');
    const container = multi || single;
    
    if (!container) return '';
    
    // Try to get individual model names from child elements first
    const children = Array.from(container.children || []);
    if (children.length > 0) {
      const models = children
        .map(child => (child.innerText || child.textContent || '').replace(/\s+/g, ' ').trim())
        .filter(Boolean);
      if (models.length > 1) {
        return models.join(', ');
      }
    }
    
    // Fallback: split on common delimiters (newlines, <br>, etc.)
    const html = container.innerHTML || '';
    if (/<br\s*\/?>/i.test(html)) {
      const models = html
        .split(/<br\s*\/?>/gi)
        .map(chunk => chunk.replace(/<\/?[^>]+>/g, '').replace(/\s+/g, ' ').trim())
        .filter(Boolean);
      if (models.length > 1) {
        return models.join(', ');
      }
    }
    
    // Final fallback: use innerText but try to detect concatenated models
    // by looking for patterns like "Model1 YY-YYModel2" (year range followed immediately by uppercase)
    let raw = (container.innerText || container.textContent || '').replace(/\s+/g, ' ').trim();
    
    // Insert comma+space before model names that follow year ranges without space
    // Pattern: digit followed by uppercase letter (like "08-20Dorsoduro")
    raw = raw.replace(/(\d{2}-\d{2})([A-Z])/g, '$1, $2');
    
    return raw;
  };

  const buildModelFilterUrl = (baseCollectionUrlWithMake, modelValue) => {
    const base = new URL(baseCollectionUrlWithMake, window.location.origin);
    base.searchParams.set('sort_by', 'title-ascending');
    base.searchParams.set('filter.p.m.custom.model', modelValue);
    return base.toString();
  };

  const handleize = (value) =>
    String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  // For filtered category menus, fetch from make collection + product_type filter
  // to reduce result set size and keep model options focused.
  const buildOptimizedFacetSourceUrl = (rawUrl) => {
    try {
      const source = new URL(rawUrl, window.location.origin);
      const make = source.searchParams.get('filter.p.m.custom.make');
      if (!make) return source.toString();

      const categoryHandle = source.pathname.replace('/collections/', '').replace(/^\/+|\/+$/g, '');
      const productTypeMap = {
        'rider-seat-covers': 'Rider Seat Covers',
        'passenger-seat-covers': 'Passenger Seat Covers',
        'tank-grips': 'Tank Grips'
      };
      const productType = productTypeMap[categoryHandle];
      if (!productType) return source.toString();

      const makeHandle = handleize(make);
      const optimized = new URL(`/collections/${makeHandle}`, window.location.origin);
      optimized.searchParams.set('filter.p.product_type', productType);
      optimized.searchParams.set('filter.p.m.custom.make', make);
      optimized.searchParams.set('sort_by', 'best-selling');
      return optimized.toString();
    } catch (e) {
      return rawUrl;
    }
  };

  const applyTierScrollStyles = (submenuEl) => {
    if (!submenuEl) return;
    // Keep long model lists accessible inside the mega menu.
    submenuEl.style.setProperty('overflow-y', 'auto', 'important');
    submenuEl.style.setProperty('overflow-x', 'hidden', 'important');
    submenuEl.style.setProperty('overscroll-behavior', 'contain', 'important');
    submenuEl.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    submenuEl.style.setProperty('max-height', 'calc(100vh - 160px)', 'important');
    // Override theme multi-column rules that currently clip part of the list.
    submenuEl.style.setProperty('column-width', 'auto', 'important');
    submenuEl.style.setProperty('column-count', '1', 'important');
    submenuEl.style.setProperty('column-gap', '0', 'important');
    submenuEl.style.setProperty('columns', 'auto', 'important');

    // Force each row to remain a single full-width block.
    submenuEl.querySelectorAll(':scope > li').forEach((li) => {
      li.style.setProperty('display', 'block', 'important');
      li.style.setProperty('float', 'none', 'important');
      li.style.setProperty('width', '100%', 'important');
      li.style.setProperty('break-inside', 'avoid', 'important');
      li.style.setProperty('break-inside', 'avoid-column', 'important');

      const wrap = li.querySelector(':scope > .navlink_to_generate');
      if (wrap) {
        wrap.style.setProperty('display', 'block', 'important');
        wrap.style.setProperty('width', '100%', 'important');
      }

      const link = li.querySelector(':scope > .navlink_to_generate > a.navlink');
      if (link) {
        link.style.setProperty('display', 'block', 'important');
        link.style.setProperty('width', '100%', 'important');
        link.style.setProperty('justify-content', 'flex-start', 'important');
      }
    });
  };

  async function loadMenuModels(menu) {
    const container = menu.closest('.navlink_to_generate')?.querySelector('ul.sub-menu');
    if (!container) return;

    const dataUrl = menu.getAttribute('data-url');
    if (!dataUrl) return;
    const url = buildOptimizedFacetSourceUrl(dataUrl);
    const makeLabel = (menu.querySelector('.navtext')?.textContent || menu.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
    const shopAllLabel = makeLabel ? `Shop All ${makeLabel}` : 'Shop All';
    const shopAllUrl = new URL(url, window.location.origin);
    // Ensure this top link points to the make/category listing, not a model-filtered URL.
    shopAllUrl.searchParams.delete('filter.p.m.custom.model');

    const cacheKey = `menu-cache-${CACHE_VERSION}-${url}`;
    if (container.dataset.loaded === 'true') return;

    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      try {
        const { timestamp, html } = JSON.parse(cached);
        if (Date.now() - timestamp < ONE_WEEK) {
          container.innerHTML = html;
          applyTierScrollStyles(container);
          container.dataset.loaded = 'true';
          return;
        }
      } catch (e) {}
    }

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      let items = [];
      const modelFacetUl = getModelFacetUl(doc);
      if (modelFacetUl) {
        // Preferred: facet values are collection-wide and not pagination-limited.
        items = extractOptionsFromUl(modelFacetUl)
          .map((opt) => ({
            title: opt.text,
            value: opt.value || opt.text,
            key: normalize(opt.text)
          }))
          .filter((i) => i.title && i.key);
      } else {
        // Fallback: scrape visible product cards on fetched page.
        const productElements = Array.from(doc.querySelectorAll('.product-grid-item'));
        items = productElements
          .map((productEl) => {
            const title = getModelTitleFromCard(productEl);
            return { title, value: title, key: normalize(title) };
          })
          .filter((i) => i.title && i.key);
      }

      items.sort((a, b) => a.key.localeCompare(b.key));
      container.innerHTML = '';

      const shopAllHTML = `
        <li>
          <div class="navlink_to_generate">
            <a class="navlink navlink--child navlink--shop-all main-menu--active" href="${shopAllUrl.toString()}">
              <span class="navtext">${shopAllLabel}</span>
            </a>
          </div>
        </li>
      `;
      container.insertAdjacentHTML('beforeend', shopAllHTML);

      let htmlToCache = shopAllHTML;
      let lastKey = null;
      items.forEach(({ title, value, key }) => {
        if (key === lastKey) return;
        lastKey = key;
        const href = buildModelFilterUrl(url, value);
        const liHTML = `
          <li>
            <div class="navlink_to_generate">
              <a class="navlink navlink--child main-menu--active" href="${href}">
                <span class="navtext">${title}</span>
              </a>
            </div>
          </li>
        `;
        container.insertAdjacentHTML('beforeend', liHTML);
        htmlToCache += liHTML;
      });

      localStorage.setItem(
        cacheKey,
        JSON.stringify({ timestamp: Date.now(), html: htmlToCache })
      );
      applyTierScrollStyles(container);
      container.dataset.loaded = 'true';
    } catch (err) {
      console.error('Failed to load submenu products:', err);
    }
  }

  // ---------- submenu loader (legacy menus) ----------
  document.querySelectorAll('.js-custom-menu').forEach((menu) => {
    menu.addEventListener('mouseenter', async function () {
      if (menu.closest('.menu__item.shop-by-category')) return;
      await loadMenuModels(menu);
    });
  });

  // ---------- Position 3rd tier submenu relative to hovered item ----------
  // This ensures the 3rd tier dropdown appears at the same vertical level
  // as the hovered make item, making it visible regardless of scroll position
  // Using event delegation to handle dynamically created elements
  $(document).on('mouseenter', '.navlink_to_generate', function() {
    if (this.closest('.menu__item.shop-by-category')) return;
    const container = this;
    const submenu = container.querySelector('ul.sub-menu');
    if (!submenu) return;
    
    // Small delay to allow submenu to render/load
    setTimeout(() => {
      // Get the position of the hovered item
      const containerRect = container.getBoundingClientRect();
      const headerDropdown = container.closest('.header__dropdown__wrapper');
      
      if (headerDropdown) {
        const headerRect = headerDropdown.getBoundingClientRect();
        
        // Calculate how far down the item is relative to the dropdown
        const offsetFromTop = containerRect.top - headerRect.top;
        
        // Calculate available space below
        const viewportHeight = window.innerHeight;
        const spaceBelow = viewportHeight - containerRect.top;
        const submenuHeight = submenu.scrollHeight || 400; // Estimate if not yet rendered
        
        // If submenu would overflow below viewport, adjust position upward
        let topPosition = 0;
        if (spaceBelow < submenuHeight) {
          // Position so bottom of submenu aligns with bottom of viewport (with padding)
          topPosition = Math.max(-(submenuHeight - spaceBelow + 20), -offsetFromTop);
        }
        
        submenu.style.top = topPosition + 'px';
      }
    }, 50);
  });

  // ---------- Shop by Category behavior ----------
  (function initShopByCategoryMenu() {
    const menuItem = document.querySelector('.header__desktop .menu__item.shop-by-category');
    if (!menuItem) return;
    const topLink = menuItem.querySelector(':scope > a[data-top-link]');
    const dropdown = menuItem.querySelector(':scope > .header__dropdown[data-hover-disclosure]');
    const headerWrapper = menuItem.closest('[data-header-wrapper]');
    const dropdownWrapper = dropdown?.querySelector('.header__dropdown__wrapper');
    if (!topLink || !dropdown || !headerWrapper || !dropdownWrapper) return;

    const alignDropdownToViewport = () => {
      const anchorRect = (topLink || menuItem).getBoundingClientRect();
      dropdown.style.setProperty('--sbc-dropdown-top', `${Math.max(0, Math.round(anchorRect.bottom))}px`);
      dropdown.style.left = '0px';
      dropdown.style.right = '0px';
      dropdown.style.width = `${document.documentElement.clientWidth}px`;
      dropdown.style.maxWidth = 'none';
    };

    const setPinned = (open) => {
      if (open) alignDropdownToViewport();
      menuItem.classList.toggle('is-sbc-pinned', open);
      menuItem.classList.toggle('is-visible', open);
      dropdown.classList.toggle('is-visible', open);
      menuItem.setAttribute('aria-expanded', open ? 'true' : 'false');
      headerWrapper.classList.toggle('meganav--visible', open);
      if (!open) {
        dropdownWrapper.querySelectorAll('.sbc-tier1.is-sbc-active, .sbc-tier2-row.is-sbc-open').forEach((el) => {
          el.classList.remove('is-sbc-active', 'is-sbc-open');
        });
        const closePromos = dropdownWrapper.querySelector('[data-sbc-mega-promos]');
        if (closePromos) {
          closePromos.hidden = true;
          closePromos.querySelectorAll('.sbc-mega-promo').forEach((el) => { el.hidden = true; });
        }
        activeMakeLink = null;
        closeModelPane();
      }
    };

    topLink.addEventListener('click', (evt) => {
      evt.preventDefault();
      setPinned(!menuItem.classList.contains('is-sbc-pinned'));
    });
    menuItem.addEventListener('mouseenter', alignDropdownToViewport);
    menuItem.addEventListener('focusin', alignDropdownToViewport);

    const keepOpen = (evt) => {
      if (menuItem.classList.contains('is-sbc-pinned')) {
        evt.stopImmediatePropagation();
      }
    };
    menuItem.addEventListener('mouseleave', keepOpen, true);
    menuItem.addEventListener('focusout', keepOpen, true);

    document.addEventListener('click', (evt) => {
      if (!menuItem.classList.contains('is-sbc-pinned')) return;
      if (!menuItem.contains(evt.target)) setPinned(false);
    });

    document.addEventListener('keyup', (evt) => {
      if (evt.key === 'Escape') setPinned(false);
    });

    let lastWindowScrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      if (Math.abs(currentScrollY - lastWindowScrollY) < 2) return;
      lastWindowScrollY = currentScrollY;
      if (
        menuItem.classList.contains('is-sbc-pinned') ||
        menuItem.classList.contains('is-visible') ||
        dropdown.classList.contains('is-visible')
      ) {
        setPinned(false);
      }
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (menuItem.classList.contains('is-sbc-pinned')) alignDropdownToViewport();
    });

    const promoContainer = dropdownWrapper.querySelector('[data-sbc-mega-promos]');
    const modelPane = document.createElement('ul');
    modelPane.className = 'sub-menu sbc-tier3 sbc-model-pane';
    modelPane.setAttribute('data-sbc-tier', '3');
    modelPane.hidden = true;
    dropdownWrapper.appendChild(modelPane);

    const closeModelPane = () => {
      modelPane.hidden = true;
      modelPane.innerHTML = '';
    };

    const handleMenuWheel = (evt) => {
      const pane = evt.target.closest('.sbc-tier2, .sbc-model-pane, .sbc-mega-promos');
      if (pane && dropdownWrapper.contains(pane) && pane.scrollHeight > pane.clientHeight) {
        pane.scrollTop += evt.deltaY;
      }
      evt.preventDefault();
      evt.stopPropagation();
    };

    dropdown.addEventListener('wheel', handleMenuWheel, { passive: false });

    const updateTier1Promos = (activeHandle) => {
      if (!promoContainer) return;
      const promos = promoContainer.querySelectorAll('.sbc-mega-promo[data-sbc-promo-for]');
      let anyVisible = false;
      promos.forEach((el) => {
        const match = el.getAttribute('data-sbc-promo-for') === activeHandle;
        el.hidden = !match;
        if (match) anyVisible = true;
      });
      promoContainer.dataset.sbcActive = anyVisible ? activeHandle : '';
      promoContainer.hidden = !anyVisible;
    };

    const activateTier1 = (tier1El) => {
      // Do not reset pane 4 when still inside the same tier-1 branch.
      if (tier1El.classList.contains('is-sbc-active')) return;
      dropdownWrapper.querySelectorAll('.sbc-tier1.is-sbc-active').forEach((el) => el.classList.remove('is-sbc-active'));
      dropdownWrapper.querySelectorAll('.sbc-tier2-row.is-sbc-open').forEach((el) => el.classList.remove('is-sbc-open'));
      closeModelPane();
      tier1El.classList.add('is-sbc-active');
      const tier1Link = tier1El.querySelector(':scope > a.navlink-custom');
      const handle = tier1Link?.getAttribute('data-link-handle') || '';
      updateTier1Promos(handle);
    };

    let activeMakeLink = null;

    const openMakeModels = async (makeLink) => {
      const makeRow = makeLink.closest('.sbc-tier2-row');
      const tier2 = makeRow?.closest('.sbc-tier2');
      if (!makeRow || !tier2) return;
      if (activeMakeLink === makeLink && !modelPane.hidden) return;

      activeMakeLink = makeLink;
      tier2.querySelectorAll('.sbc-tier2-row.is-sbc-open').forEach((el) => el.classList.remove('is-sbc-open'));
      makeRow.classList.add('is-sbc-open');
      await loadMenuModels(makeLink);

      const tier3 = makeRow.querySelector('.sbc-tier3');
      if (!tier3 || activeMakeLink !== makeLink) return;
      modelPane.innerHTML = tier3.innerHTML;
      modelPane.hidden = false;
      applyTierScrollStyles(modelPane);
    };

    dropdownWrapper.addEventListener('mouseover', (evt) => {
      const tier1Link = evt.target.closest('.sbc-tier1 > a.navlink-custom');
      if (tier1Link) {
        const tier1El = tier1Link.closest('.sbc-tier1');
        if (tier1El && dropdownWrapper.contains(tier1El)) activateTier1(tier1El);
        return;
      }

      const makeLink = evt.target.closest('.sbc-tier2-row > a.js-custom-menu');
      if (makeLink && dropdownWrapper.contains(makeLink)) openMakeModels(makeLink);
    });

    dropdownWrapper.addEventListener('click', async (evt) => {
      const tier1Link = evt.target.closest('.sbc-tier1 > a.navlink-custom');
      if (tier1Link) {
        const tier1El = tier1Link.closest('.sbc-tier1');
        if (tier1El?.dataset.sbcDirect === 'true') return;
        evt.preventDefault();
        if (tier1El) activateTier1(tier1El);
        return;
      }

      const makeLink = evt.target.closest('.sbc-tier2-row > a.js-custom-menu');
      if (makeLink) {
        evt.preventDefault();
        await openMakeModels(makeLink);
      }
    });

    // Keep selected tier state sticky while the mega menu is open.
    // State resets via top-level close (outside click / ESC / toggle).
  })();

  // ---------- Full-width custom mega menus ----------
  (function initFullWidthHeaderMegamenus() {
    const menuItems = Array.from(document.querySelectorAll('.header__desktop .menu__item:not(.shop-by-category)'))
      .filter((menuItem) => menuItem.querySelector(':scope > .header__dropdown[data-hover-disclosure]'));
    if (!menuItems.length) return;

    const getScrollableElement = (target, boundary) => {
      let el = target;
      while (el && el !== boundary) {
        if (el.scrollHeight > el.clientHeight) return el;
        el = el.parentElement;
      }
      return null;
    };

    const alignDropdown = (menuItem) => {
      const dropdown = menuItem.querySelector(':scope > .header__dropdown[data-hover-disclosure]');
      if (!dropdown) return;
      menuItem.classList.add('custom-mega-full-width');
      const topLink = menuItem.querySelector(':scope > a[data-top-link], :scope > a.navlink--toplevel');
      const anchorRect = (topLink || menuItem).getBoundingClientRect();
      dropdown.style.setProperty('--custom-mega-dropdown-top', `${Math.max(0, Math.round(anchorRect.bottom))}px`);
      dropdown.style.left = '0px';
      dropdown.style.right = '0px';
      dropdown.style.width = `${document.documentElement.clientWidth}px`;
      dropdown.style.maxWidth = 'none';
      if (dropdown.dataset.scrollContained !== 'true') {
        dropdown.dataset.scrollContained = 'true';
        dropdown.addEventListener('wheel', (evt) => {
          const scrollableEl = getScrollableElement(evt.target, dropdown);
          if (scrollableEl) scrollableEl.scrollTop += evt.deltaY;
          evt.preventDefault();
          evt.stopPropagation();
        }, { passive: false });
      }
    };

    menuItems.forEach((menuItem) => {
      menuItem.addEventListener('mouseenter', () => alignDropdown(menuItem));
      menuItem.addEventListener('focusin', () => alignDropdown(menuItem));
    });

    let lastWindowScrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;
      if (Math.abs(currentScrollY - lastWindowScrollY) < 2) return;
      lastWindowScrollY = currentScrollY;
      menuItems.forEach((menuItem) => {
        const dropdown = menuItem.querySelector(':scope > .header__dropdown[data-hover-disclosure]');
        if (!dropdown) return;
        menuItem.classList.remove('is-visible');
        dropdown.classList.remove('is-visible');
      });
    }, { passive: true });

    window.addEventListener('resize', () => {
      menuItems.forEach((menuItem) => {
        if (menuItem.matches(':hover') || menuItem.contains(document.activeElement)) alignDropdown(menuItem);
      });
    });
  })();

  // ---------- keep your existing scroll behaviour ----------
  $(window).scroll(function () {
    if (window.scrollY == 0) {
      $('.product-add-popdown').removeClass('hasScrolled');
    } else {
      $('.product-add-popdown').addClass('hasScrolled');
    }
  });

  // ---------- choose your vehicle: reveal header filter row (markup: snippets/header-choose-vehicle-bar.liquid) ----------
  const toggleVehicleBar = ({ closeDrawer = false } = {}) => {
    const $bar = $('.header__desktop__bar__m');
    if (!$bar.length) return;

    // `hidden` can override jQuery toggle in some browsers/theme states.
    const currentlyHidden = $bar.attr('hidden') !== undefined || !$bar.is(':visible');
    if (currentlyHidden) {
      $bar.removeAttr('hidden').show();
      if (closeDrawer) {
        try {
          document.querySelector('button.drawer__close[data-drawer-toggle="hamburger"]')?.click();
        } catch (err) { /* ignore */ }
      }
      try {
        $bar[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } catch (err) { /* ignore */ }
    } else {
      $bar.hide().attr('hidden', '');
    }
  };

  $(document)
    .off('click.menuVehicle', '.menu__item.choose-your-vehicle a, .menu__item.choose-your-vehicle')
    .on('click.menuVehicle', '.menu__item.choose-your-vehicle a, .menu__item.choose-your-vehicle', function (e) {
      e.preventDefault();
      toggleVehicleBar();
    });

  // Capture-phase safety for desktop nav scripts that may stop bubbling before delegated handlers.
  document.addEventListener('click', function (e) {
    const desktopVehicleTrigger = e.target?.closest?.('.header__desktop .menu__item.choose-your-vehicle a, .header__desktop .menu__item.choose-your-vehicle');
    if (!desktopVehicleTrigger) return;
    e.preventDefault();
    e.stopPropagation();
    toggleVehicleBar();
  }, true);

  $(document)
    .off('click.menuVehicleMobile', '.choose-your-vehicle-mobile a, .choose-your-vehicle-mobile .sliderow__title')
    .on('click.menuVehicleMobile', '.choose-your-vehicle-mobile a, .choose-your-vehicle-mobile .sliderow__title', function (e) {
      e.preventDefault();
      toggleVehicleBar({ closeDrawer: true });
    });
})();


  $(document).on('click', '.tab-link', function () {
    var tabIndex = $(this).data('tab');
    $(".tab-collection-link").hide();
    $(".tab-collection-link-" + tabIndex).fadeIn(1000);
  });

  const collection_card_sliders = document.querySelectorAll(".collection-card-slider");
  collection_card_sliders.forEach((section, i) => {
    var section_id = $(section).data('section-id');
    init_collection_slider(section_id);
  });
  function init_collection_slider(section_id) {
    $('.ccs-' + section_id).slick({
      speed: 400,
      dots: false,
      cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
      touchThreshold: 10,
      slidesToShow: 3.2,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      prevArrow: $('.csg-prev-' + section_id),
      nextArrow: $('.csg-next-' + section_id),
      responsive: [
        { breakpoint: 900, settings: { slidesToShow: 2.5 } },
        { breakpoint: 769, settings: { slidesToShow: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1 } }
      ]
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $(".csg-prev-" + section_id).removeClass('at-end')
      $(".csg-next-" + section_id).removeClass('at-end')
      if (currentSlide == 1 && nextSlide == 0) {
        $(".csg-prev-" + section_id).addClass('at-end')
      }
      if (slick.$slides.length == (nextSlide + slick.options.slidesToShow)) {
        $(".csg-next-" + section_id).addClass('at-end')
      }
    });
  }

  $('.collection-card-link-slider').slick({
    speed: 700,
    dots: false,
    cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    "prevArrow": $('.csl-prev'),
    "nextArrow": $('.csl-next'),
    responsive: [
      { breakpoint: 900, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } }
    ]
  }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $(".csl-prev").removeClass('at-end')
    $(".csl-next").removeClass('at-end')
    if (currentSlide == 1 && nextSlide == 0) {
      $(".csl-prev").addClass('at-end')
    }
    if (slick.$slides.length == (nextSlide + slick.options.slidesToShow)) {
      $(".csl-next").addClass('at-end')
    }
  });

  // product page | update variant sku in breadcrumb
  $('.show-variant-sku--true .radio__button input').click(function () {
    $('.current-sku').text($(this).data('variant-sku'));
  });
  $('.show-variant-barcode--true .radio__button input').click(function () {
    $('.current-barcode').text($(this).data('variant-barcode'));
  });
  
  $('.radio__button input, .swatch__button input').on('click load', function () {
    if ( $(this).data('variant-inventory') <= 0 &&  $(this).data('variant-inventory_policy').indexOf('continue') >= 0 ) {
      $('.variant__countdown').addClass('count-is-0')
    } else {
      $('.variant__countdown').removeClass('count-is-0')
    }
  }).filter(':checked').trigger('load');

  // Hides / shows BUY FROM OUR RETAILERS buttons corresponding to the variant that is clicked.
  $('.form__selectors input').click(function () {
    var _val = $(this).data('variant-sku');
    $('.cswidget-wrapper button').each(function () {
      if (_val === $(this).data('product-sku')) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });

  const $form = $('form[action="/cart/add"]');
  const $requiredFields = $form.find('.required');
  const $addToCartBtn = $form.find('button[type="submit"]');

  if ($requiredFields.length > 0) {
    $addToCartBtn.prop('disabled', true);
  }
  const validateForm = function() {
    const isValid = $requiredFields.toArray().every(function(field) {
      return field.value !== '';
    });
    $addToCartBtn.prop('disabled', !isValid);
  };
  $requiredFields.on('input', validateForm);

  // Testimonial Sliders
  if ($('.custom--section-quotes .quotes-slider').length) {
    $('.custom--section-quotes .quotes-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      arrows: false,
      dots: true
    });
  }

  $('.product-slider .product-item').slick({
    infinite: false,
    slidesToShow: 3.6,
    arrows: true,
    prevArrow: $(".product-slider .csg-prev"),
    nextArrow: $(".product-slider .csg-next"),
    dots: false,
    responsive: [
      { breakpoint: 900, settings: { slidesToShow: 3 } },
      { breakpoint: 599, settings: { slidesToShow: 1.2 } }
    ]
  });

  // open external links in new tab
  var links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname && !links[i].classList.contains("non-external")) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  // update cart number on cart page
  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      let cart_count = cart.item_count
      if (cart_count == 1) {
        $('.general-title-count span').text(cart.item_count.toString() + " item");
      } else {
        $('.general-title-count span').text(cart.item_count.toString() + " items");
      }
    }
  });

  // focus on search dropdown when clicked
  $('.desktop-search').click(function (e){
    e.preventDefault();
    $('#search-popdown').addClass('is-visible');
    $('.search__predictive__main input[type="search"]').focus();
  });

  // search dropdown
  $('#searchLink').click(function (e) {
    e.preventDefault();
    setTimeout(function (){	
      $(".search__predictive__form__button").click();
    }, 100)
  });

})();

$('.inventory-info, .drawer-container > .drawer__button.drawer__close, .drawer-container + .drawer-bg').click(function(e){
  e.preventDefault();
  $('.drawer-container, body').toggleClass('open');
  $('.drawer-container > .drawer__button.drawer__close').focus();
  $('.drawer-container').keyup(function(event){
    if (event.keyCode == 27 ){
      $('.drawer-container, body').removeClass('open');
    }
  });
});

$('.seat-inserts, .seat-inserts-drawer > .drawer__button.drawer__close, .seat-inserts-drawer + .drawer-bg').click(function (e) {
  e.preventDefault();
  $('.seat-inserts-drawer, body').toggleClass('open');
  $('.seat-inserts-drawer > .drawer__button.drawer__close').focus();
  $('.seat-inserts-drawer').keyup(function (event) {
    if (event.keyCode == 27) {
      $('.seat-inserts-drawer, body').removeClass('open');
    }
  });
});

// Trigger for opening GorgiasChat widget
$('a').click(function(e) {
  var linkText = $(this).text();
  if (linkText.includes('Live Chat') || linkText.includes('Start a live chat') || linkText.includes('Talk to us')) {
    e.preventDefault();
    GorgiasChat.open();
  }
});

// Remove all links that contains Wholesale 
if ($('.customer_not_wholesaler').length) { 
  $('a').filter(function() {
    return $(this).text().indexOf('Wholesale') !== -1;
  }).remove();
}
if ($('.customer_not_wholesaler').length) { 
  $('a').filter(function() { 
    return $(this).text().indexOf('Wholesale') !== -1;
  }).remove();
}

$(document).ready(function() {
  // custom related section
  $('.related__products .flickity-viewport').ready(function() {
    setTimeout(function(){ 
      $('.related__products .product-grid-slide').css({ 'top': '0', 'bottom': '0' });
    }, 1000);
  });

  // swatch colours on grid
  function updateSwatches() {
    setTimeout(function(){ 
      $('.grid__swatch__container, .related__products .grid__swatch__container').each(function() {

        var product = $(this).data('product-handle');

        fetch('/products/' + product +'?view=metafields', {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        })
          .then(function(response) {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
          })
          .then(function(data) {
            var variants_list = data.metafields;
            var arrayLength = variants_list.length;
            for (var i = 0; i < arrayLength; i++) {
              $("label[data-swatch-variant="+variants_list[i].variant_id+"]").css('background', variants_list[i].color);
            }
          })
          .catch(function(error) {
            console.error('There was a problem with the fetch operation:', error);
          });

      });
    }, 1000);
  }
  updateSwatches();

  var targetNode = document.body;
  var config = { childList: true, subtree: true };
  var observer_swatch = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length > 0) {
        $(mutation.addedNodes).find('.grid__swatch__container').each(function() {
          updateSwatches();
        });
      }
    });
  });
  observer_swatch.observe(targetNode, config);

  // Predictive search enrichment
  const observer = new MutationObserver(function(mutations) {
    setTimeout(function(){ 
      mutations.forEach(function(mutation) {
        if ($(mutation.addedNodes).hasClass('product__inline')) {
          $('.search__results__products__list .product__inline').each(function() {
            var product_handle = $(this).data('product-handle');
            var $productMetafields = $(this).find(".product-metafields-info");
            fetch('/products/' + product_handle +'?view=predictive-search', {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' },
            })
              .then(function(response) {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
              })
              .then(function(data) {
                var make = data.metafields[0].make;
                var model = data.metafields[0].model; 
                var shortened_product_title = data.metafields[0].shortened_product_title; 
                var options_available = data.metafields[0].options_available; 

                if ( make !== "" ) {
                  $productMetafields.find(".make")
                  .fadeOut(200, function() {
                    $(this).text(make + " | ").fadeIn(100);
                  });
                } 
                if ( model !== "" ) {
                  $productMetafields.find(".model")
                  .fadeOut(200, function() {
                    $(this).text(model).fadeIn(100);
                  });
                }
                if ( shortened_product_title !== "" ) {
                  $productMetafields.find(".product__inline__title")
                  .fadeOut(200, function() {
                    $(this).text(shortened_product_title).fadeIn(100);
                  });
                }
                if ( options_available !== "" ) {
                  $productMetafields.find(".options-available")
                  .fadeOut(200, function() {
                    $(this).text(options_available).fadeIn(100);
                  });
                }
              })
              .catch(function(error) {
                console.error('There was a problem with the fetch operation:', error);
              });
          });
          observer.disconnect();
        }
      });
    }, 300);
  });
  observer.observe($('.search__results__products__list')[0], {
    childList: true,
    attributes: false,
    characterData: false
  });
  $('input[name="q"]').on('input', function() {
    observer.observe($('.search__results__products__list')[0], {
      childList: true,
      attributes: false,
      characterData: false
    });
  });

});

'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.11
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    method: [options are 'scroll', 'click']
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  // Bind 'this' to applicable prototype functions
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  // Set up our element selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  if (this.containerElement) {
    var initializers = { click: this.addClickListener, scroll: this.addScrollListeners };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  var destroyers = { click: this.removeClickListener, scroll: this.removeScrollListener };
  destroyers[this.settings.method]();
  return this;
};
